// src/pages/TermsPage.jsx
import React from 'react';
import IntroImage from '../images/241BusinessAIKit_Flat.jpg';

export default function TermsPage() {
  return (
    <article className="terms-page">

      <section className="section-organizer jury-policy__intro">
        <h1 className="section-title">
          Положение о проведении Международной премии International CMO Summit Awards
        </h1>
        <div className="jury-policy__intro-image">
          <img
            src={IntroImage}
            alt="Победители International CMO Summit Awards"
          />
        </div>
      </section>

      <section className="terms-section">
        <h2 className="terms-section__title">1. ОБЩИЕ ПОЛОЖЕНИЯ</h2>
        <p>
          1.1. Международная премия International Chief Marketing Officer Summit Awards (далее — «Премия»)
          учреждена Украинской Ассоциацией Маркетинга (УАМ) в 2019 году как ежегодная высокоселективная
          профессиональная награда в области стратегического, корпоративного и международного маркетинга.
        </p>
        <p>
          1.2. Цель Премии — идентификация, признание и документальное подтверждение экстраординарных
          достижений отдельных лиц в сфере маркетинга, обладающих подтверждённым международным влиянием
          и лидирующей профессиональной репутацией.
        </p>
        <p>
          1.3. Премия проводится в онлайн-формате и охватывает участников из более чем 25 государств,
          включая страны СНГ, Центральной Азии, Восточной Европы, Ближнего Востока и Южной Азии.
        </p>
        <p>
          1.4. Премия присуждается исключительно физическим лицам на основании независимого экспертного
          отбора, проводимого в соответствии с установленными критериями и процедурами, изложенными в
          настоящем Положении.
        </p>
      </section>

      <section className="terms-section">
        <h2 className="terms-section__title">2. ОРГАНИЗАТОР И ЮРИСДИКЦИЯ</h2>
        <p>
          2.1. Организатором Премии является Украинская Ассоциация Маркетинга (УАМ), действующий член
          международных профессиональных организаций ESOMAR, IAA и IBA Europe.
        </p>
        <p>
          2.2. Организатор несет ответственность за администрирование процедуры подачи, оценку заявок,
          формирование жюри, верификацию доказательной базы, публикацию результатов и соблюдение
          этических стандартов.
        </p>
      </section>

      <section className="terms-section">
        <h2 className="terms-section__title">3. ЦЕЛИ И ЗАДАЧИ ПРЕМИИ</h2>
        <p>
          3.1. Признание и продвижение специалистов, осуществивших значительное влияние на развитие
          индустрии маркетинга через стратегии, трансформации брендов, цифровые инновации, ESG-инициативы
          и международные кейсы.
        </p>
        <p>
          3.2. Повышение стандартов профессиональной практики маркетинга в международном контексте.
        </p>
        <p>
          3.3. Формирование достоверной и проверяемой базы достижений, пригодной для использования в
          процедурах профессиональной аккредитации, академической и деловой репутации.
        </p>
      </section>

      <section className="terms-section">
        <h2 className="terms-section__title">4. НОМИНАЦИИ ПРЕМИИ</h2>
        <p>
          4.1. Премия включает 11 персональных номинаций, охватывающих ключевые аспекты маркетинга,
          включая:
        </p>
        <ul className="terms-list">
          <li>CMO of the Year</li>
          <li>Strategic Visionary of the Year</li>
          <li>Global Marketing Leader</li>
          <li>Innovation Catalyst in Marketing</li>
          <li>Sustainability Marketing Leader</li>
          <li>Brand Transformation Architect</li>
          <li>Data-Driven Decision Maker</li>
          <li>CMO Impact Award</li>
          <li>Cross-Cultural Communication Champion</li>
          <li>Reputation & Trust Builder</li>
          <li>Team Leadership Excellence</li>
        </ul>
      </section>

      <section className="terms-section">
        <h2 className="terms-section__title">5. УЧАСТИЕ И ПОДАЧА ЗАЯВКИ</h2>
        <p>
          5.1. Право на участие в Премии предоставляется исключительно физическим лицам, профессионально
          действующим в сфере стратегического, корпоративного или международного маркетинга, при соблюдении:
        </p>
        <ul className="terms-list">
          <li>
            лицо должно занимать управленческую должность не ниже уровня Chief Marketing Officer, Vice President Marketing или Head of Marketing на момент подачи заявки;
          </li>
          <li>
            совокупный стаж профессиональной деятельности на указанном уровне должен составлять не менее трёх (3) лет;
          </li>
          <li>
            профессиональная деятельность заявителя должна быть подтверждена конкретными результатами,
            имеющими измеримое и документально подтверждённое воздействие на бизнес-показатели компании,
            бренд или соответствующий сектор индустрии.
          </li>
        </ul>
        <p>
          5.2. Участие в Премии является строго индивидуальным. Групповые, коллективные,
          институциональные или корпоративные заявки не допускаются. Самономинирование
          (self-nomination) исключено. Выдвижение кандидатур осуществляется исключительно от имени
          отраслевых профессиональных объединений, аккредитованных партнёров-кураторов либо
          утверждённых номинационных комитетов.
        </p>
        <p>
          5.3. Для признания заявки допустимой к рассмотрению, номинируемый кандидат обязан представить
          полный и корректный комплект конкурсной документации, содержащий:
        </p>
        <ul className="terms-list">
          <li>надлежащим образом заполненную анкету-заявление установленного образца;</li>
          <li>
            описательный стратегический кейс с раскрытием целей проекта, этапов реализации,
            применённых методик и достигнутых результатов;
          </li>
          <li>
            подтверждённые количественные и качественные метрики, характеризующие эффективность проекта
            (ROI, рост выручки, изменение рыночной доли, digital-показатели, уровень узнаваемости бренда
            и вовлечённости целевой аудитории);
          </li>
          <li>
            доказательства реализации и признания проекта в профессиональном сообществе, включая
            публикации в авторитетных отраслевых СМИ, профессиональных рецензиях, интервью, экспертных
            обзорах, упоминаниях в индустриальных или академических источниках.
          </li>
        </ul>
        <p>
          5.4. Специфические требования к каждой из номинаций, а также соответствующие критерии оценки,
          изложены в разделе «Номинации и критерии оценки» настоящего Положения. Допуск к участию
          осуществляется исключительно при условии полного соответствия заявителя данным требованиям.
        </p>
      </section>

      <section className="terms-section">
        <h2 className="terms-section__title">6. ПРОЦЕДУРА ОТБОРА</h2>
        <p>6.1. Все представленные заявки подлежат обязательной двухэтапной процедуре экспертной оценки, включающей:</p>
        <ul className="terms-list">
          <li>
            техническую верификацию на предмет полноты, соответствия формальным требованиям, корректности
            предоставленных данных и соблюдения условий участия, изложенных в настоящем Положении;
          </li>
          <li>
            экспертную оценку в режиме blind review, осуществляемую независимыми членами жюри без раскрытия персональных данных заявителей.
          </li>
        </ul>
        <p>
          6.2. Оценивание проводится по принципу double-blind peer review: информация о личности
          номинанта и составе экспертной комиссии не раскрывается ни одной из сторон до завершения
          финального этапа оценки. Все члены жюри действуют в условиях полной анонимности и подписывают
          соглашение о конфиденциальности и неаффилированности.
        </p>
        <p>
          6.3. Экспертная оценка осуществляется на основании количественных и качественных критериев,
          детализированных в разделе «Номинации и критерии оценки» настоящего Положения. Каждый критерий
          имеет установленную шкалу значимости (в процентах), утверждённую организационным комитетом Премии.
        </p>
        <p>
          6.4. Все заявленные достижения, бизнес-результаты и стратегические эффекты должны быть
          подтверждены документально. Допуск к финальной стадии оценки невозможен без прохождения
          процедуры верификации данных. Отсутствие достоверных доказательств (официальных публикаций,
          показателей KPI, признания в отрасли) влечёт отклонение заявки на предварительном этапе.
        </p>
      </section>

      <section className="terms-section">
        <h2 className="terms-section__title">7. ЖЮРИ</h2>
        <p>7.1. Экспертная комиссия (далее — «Жюри») формируется из числа высококвалифицированных международных специалистов в области маркетинга, соответствующих следующим обязательным требованиям:</p>
        <ul className="terms-list">
          <li>подтверждённый опыт профессиональной деятельности на руководящих должностях уровня C-level не менее пяти лет;</li>
          <li>наличие академических публикаций в рецензируемых международных изданиях (Harvard Business Review, Journal of Marketing, Journal of International Marketing и др.);</li>
          <li>участие в качестве члена жюри, докладчика или победителя в международных конкурсах (WARC Awards, Cannes Lions, Effie Awards и др.);</li>
          <li>отсутствие конфликта интересов по отношению к номинантам, их аффилированным лицам, компаниям или организациям.</li>
        </ul>
        <p>7.2. Каждый член Жюри до начала работы подписывает следующие обязательные документы:</p>
        <ul className="terms-list">
          <li>декларацию о неаффилированности и отсутствии конфликта интересов;</li>
          <li>соглашение о конфиденциальности (NDA);</li>
          <li>обязательство соблюдать процедуры объективности, независимости и профессиональной этики.</li>
        </ul>
        <p>7.3. Жюри осуществляет оценку заявок в условиях полной анонимности (double-blind review), при которой личности номинантов и членов Жюри не раскрываются до официального объявления результатов.</p>
        <p>7.4. Решения Жюри являются окончательными, оформляются протоколом и могут быть пересмотрены только в случае установленного нарушения процедур настоящего Положения.</p>
      </section>

      <section className="terms-section">
        <h2 className="terms-section__title">8. РЕЗУЛЬТАТЫ И НАГРАДЫ</h2>
        <p>8.1. По результатам конкурсного отбора в каждой номинации определяется один победитель. Победитель получает официальный статус Лауреата Премии International CMO Summit Awards соответствующего года и награждается:</p>
        <ul className="terms-list">
          <li>официальным именным дипломом победителя с уникальным регистрационным номером и указанием полной формулировки присуждённой номинации;</li>
          <li>цифровой медалью Премии с возможностью использования в электронных и печатных профессиональных документах;</li>
          <li>официальной публикацией на веб-ресурсах Премии, Украинской Ассоциации Маркетинга и партнёрских организаций;</li>
          <li>информационной поддержкой и признанием в профильных и деловых СМИ (Forbes, VC.ru, CNews, AdIndex и др.);</li>
          <li>правом использования полученной награды в профессиональной деятельности, публичных биографических сведениях, резюме, документах для профессиональной аттестации, академических досье и иммиграционных процедурах.</li>
        </ul>
        <p>8.2. Присуждение Премии в каждой номинации осуществляется единожды в течение одного календарного года. Допущенные к финальному этапу участники, не ставшие победителями, получают официальный статус финалистов и соответствующий сертификат. Финалисты могут быть приглашены к участию в профессиональных мероприятиях, панельных сессиях и отраслевых форумах, проводимых организатором или его официальными партнёрами.</p>
        <p>8.3. Все выданные дипломы, сертификаты и медали регистрируются в едином реестре лауреатов Премии и могут быть верифицированы по официальному запросу третьих сторон.</p>
      </section>

      <section className="terms-section">
        <h2 className="terms-section__title">9. ЭТИКА, ПРИНЦИПЫ НЕЗАВИСИМОСТИ И ПРОЗРАЧНОСТИ</h2>
        <p>9.1. Все этапы организации и проведения Премии осуществляются в строгом соответствии с международными стандартами профессиональной этики, процедурной беспристрастности и прозрачности. Применяемые механизмы включают в себя:</p>
        <ul className="terms-list">
          <li>проведение оценки заявок по принципу double-blind review, обеспечивающему исключение возможности идентификации участников жюри и номинантов друг другом до завершения процедуры;</li>
          <li>обязательное подписание членами жюри соглашений о неаффилированности и конфиденциальности (NDA);</li>
          <li>верификацию всех предоставленных данных и документов, направленных участниками, с целью исключения недостоверной или недокументированной информации;</li>
          <li>проведение независимого аудита соблюдения этических норм и процедурных стандартов, осуществляемого назначенным комитетом, не участвующим в принятии решений по оценке заявок.</li>
        </ul>
        <p>9.2. Все жалобы, апелляции и заявления о нарушениях, поступающие от участников, третьих сторон или членов жюри, подлежат обязательному рассмотрению Этическим комитетом Украинской Ассоциации Маркетинга (далее — «Этический комитет»). Этический комитет действует на основании утверждённого регламента, обеспечивает объективность рассмотрения и, в случае подтверждения нарушений, имеет право:</p>
        <ul className="terms-list">
          <li>аннулировать ранее присуждённый статус победителя или финалиста;</li>
          <li>потребовать повторного рассмотрения заявки;</li>
          <li>рекомендовать внесение изменений в процедуры Премии в целях устранения выявленных недостатков.</li>
        </ul>
        <p>9.3. Принятые Этическим комитетом решения оформляются в письменной форме, направляются соответствующим сторонам и могут быть опубликованы в открытом доступе в случае, если это необходимо для соблюдения принципов публичности и добросовестности процедуры.</p>
      </section>

      <section className="terms-section">
        <h2 className="terms-section__title">10. ЗАКЛЮЧИТЕЛЬНЫЕ ПОЛОЖЕНИЯ</h2>
        <p>10.1. Настоящее Положение вступает в силу с момента публикации на официальном сайте Премии.</p>
        <p>10.2. Все изменения и обновления условий проведения Премии публикуются на сайте www.uam.in.ua.</p>
        <p>10.3. УАМ гарантирует соблюдение всех требований в соответствии с международными нормами признания заслуг и профессиональной аккредитации в области маркетинга.</p>
      </section>

    </article>
  );
}
